import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../lib/api';

const initialState = {
  networks: [],
  selected: null,
};

export const fetchNetworks = createAsyncThunk(
  'transfersTypes/fetchNetworks',
  async (_, { getState }) => {
    const { fullPhoneNumber } = getState().receiver;

    const response = await api.getNetworksList(fullPhoneNumber);

    return response.carriers;
  }
);

const networksSlice = createSlice({
  name: 'receiver',
  initialState,
  reducers: {
    selectNetwork(state, action) {
      state.selected = action.payload;
    },
  },
  extraReducers: {
    [fetchNetworks.fulfilled]: (state, action) => {
      state.networks = action.payload;

      // default can be set from server
      const selectedIndex = action.payload.findIndex((n) => n.selected);

      if (selectedIndex > -1) {
        state.selected = action.payload[selectedIndex];
      }
    },
  },
});

export const { selectNetwork } = networksSlice.actions;

export default networksSlice.reducer;
